//MARK: Done
export const DASHBOARD = {
  DASHBOARD: {
    GET: "dashboard/get",
  },
};
